



































// import Vue from "vue";
import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";

@Component({
  components: {
    Header,
  },
})
export default class extends Vue {}

// export default Vue.extend({
//   name: "App",

//   data: () => ({
//     //
//   }),
// });
